import { Firestore, getFirestore, doc, getDoc } from "firebase/firestore";
import { CartType, hasMenuCartItem } from "../../models/CartType";
import { ProfileService } from "../profile/profile";
import { FirestoreService } from "../firebase/firestoreService";
import { FullProperty } from "../../models/fullProperty";
import { restaurantService } from "../firebase/restaurantManagementService";
import { ProfileType } from "../../models/profileType";


const ORDER_HISTORY_COLLECTION_NAME = "orderHistory";
export interface OrderViewData {
    cart: CartType,
    restaurant: FullProperty
}

export const OrderHistoryService = {
    async getLatestOrder(profile: ProfileType): Promise<OrderViewData | null> {
        if (profile && profile.orders && profile.orders.length > 0) {
            const cart = (await FirestoreService.
                getDocument(ORDER_HISTORY_COLLECTION_NAME, profile.orders[profile.orders.length - 1])) as CartType | null;
            if (cart) {
                try {
                    const restaurant = await restaurantService.fetchRestaurantById(cart.restaurantId)
                    if (restaurant) {
                        return { cart, restaurant };
                    }
                } catch (error) {
                    console.log(error)
                }
            }
        }
        return null;
    },
    async getOrderById(orderId: string): Promise<CartType | null> {
        const cart = (await FirestoreService.
            getDocument(ORDER_HISTORY_COLLECTION_NAME, orderId)) as CartType | null;
        return cart
    },
    async getAllOrders(profile: ProfileType): Promise<OrderViewData[]> {
        let allOrders: OrderViewData[] = [];
        if (profile && profile.orders && profile.orders.length > 0) {
            const orders = profile.orders.reverse().map(async (cartId: string) => {
                const cart = (await FirestoreService.
                    getDocument(ORDER_HISTORY_COLLECTION_NAME, cartId)) as CartType | null;
                if (cart) {
                    const restaurant = await restaurantService.fetchRestaurantById(cart.restaurantId)
                    if (restaurant) {
                        allOrders.push({
                            cart,
                            restaurant
                        })
                    }
                }
            })
            await Promise.all(orders)
        }
        return allOrders;
    },
    async getAllOrdersByRestaurantId(restaurantId: string): Promise<{ collectedOrders: OrderViewData[], pendingOrders: OrderViewData[] }> {
        // TODO: THIS IS TERRIBLE< MOVE THIS TO THE BACKEND AND use an index to find all orders associated with a restaurant, dont keep them on the restaurant
        let collectedOrders: OrderViewData[] = [];
        let pendingOrders: OrderViewData[] = [];
        if (restaurantId.length > 0) {
            const restaurant = await restaurantService.fetchRestaurantById(restaurantId)
            const allRestaurantOrders = [
                ...restaurant.ordersCompleted,
                ...restaurant.ordersReadyForCollection,
                ...restaurant.ordersBeingPrepared,
                ...restaurant.incomingOrders
            ];
            const orders = allRestaurantOrders.reverse().map(async (cartId: string) => {
                const cart = (await FirestoreService.
                    getDocument(ORDER_HISTORY_COLLECTION_NAME, cartId)) as CartType | null;
                if (cart) {
                    if (cart.orderCollected) {
                        if (cart.items.length > 0 && hasMenuCartItem(cart.items[0])) {
                            collectedOrders.push({
                                cart,
                                restaurant
                            })
                        }
                    } else {
                        pendingOrders.push({
                            cart,
                            restaurant
                        })
                    }
                }
            })
            await Promise.all(orders)
        }
        return { collectedOrders, pendingOrders };
    }
}